// extracted by mini-css-extract-plugin
module.exports = {"staticMap":"StaticMap_staticMap__HMlzE"};